/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import {
    Paper,
    Box,
    Typography,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
    Button,
    Alert
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import AttachFileIcon from '@mui/icons-material/AttachFile';

const FileUploadSection = ({ files, onRemoveFile, onRemoveAllFiles, getRootProps, getInputProps, isDragActive, fileError }) => (
    <Paper elevation={0} variant="outlined" sx={{ p: 2 }}>
        <Box
            {...getRootProps()}
            sx={{
                border: '2px dashed',
                borderColor: isDragActive ? 'primary.main' : (fileError && 'error.main') || 'grey.400',
                borderRadius: 1,
                p: 3,
                textAlign: 'center',
                cursor: 'pointer',
                bgcolor: isDragActive ? 'action.hover' : 'background.paper',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                    bgcolor: 'action.hover',
                    borderColor: 'primary.main'
                }
            }}
        >
            <input {...getInputProps()} />
            <AttachFileIcon color={fileError ? 'error' : 'primary'} sx={{ fontSize: 40, mb: 1 }} />
            <Typography color={fileError ? 'error' : 'textSecondary'}>
                {isDragActive ? 'Drop files here...' : 'Drag & drop files here, or click to select files'}
            </Typography>
            <Typography variant="caption" color={fileError ? 'error' : 'textSecondary'}>
                Accepted files: PDF, JPG, PNG (max 5MB)
            </Typography>
        </Box>

        {fileError && (
            <Alert severity="error" sx={{ mt: 2 }}>
                {fileError}
            </Alert>
        )}

        {files.length > 0 && (
            <Box mt={2}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                    <Typography variant="subtitle2">Attached Files ({files.length})</Typography>
                    <Button startIcon={<ClearAllIcon />} size="small" color="error" onClick={onRemoveAllFiles} variant="outlined">
                        Clear All
                    </Button>
                </Box>
                <List dense>
                    {files.map((file, index) => (
                        <ListItem
                            key={index}
                            sx={{
                                border: '1px solid',
                                borderColor: 'divider',
                                borderRadius: 1,
                                mb: 0.5
                            }}
                        >
                            <ListItemText primary={file.name} secondary={`${(file.size / 1024 / 1024).toFixed(2)} MB`} />
                            <ListItemSecondaryAction>
                                <IconButton edge="end" onClick={() => onRemoveFile(index)} color="error" size="small">
                                    <DeleteIcon />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
                </List>
            </Box>
        )}
    </Paper>
);

FileUploadSection.propTypes = {
    files: PropTypes.array.isRequired,
    onRemoveFile: PropTypes.func.isRequired,
    onRemoveAllFiles: PropTypes.func.isRequired,
    getRootProps: PropTypes.func.isRequired,
    getInputProps: PropTypes.func.isRequired,
    isDragActive: PropTypes.bool.isRequired,
    fileError: PropTypes.string
};

export default FileUploadSection; 